import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
  selector: 'app-add-guidance-detail',
  templateUrl: './add-guidance-detail.component.html',
  styleUrls: ['./add-guidance-detail.component.scss'],
  standalone: false
})
export class AddGuidanceDetailComponent implements OnInit {

  constructor(
    private userdata: UserdataService,
    private toast: ToastrService,
    private guidanceService: GuidanceService,
    private route: Router,
    private spinner: NgxSpinnerService
  ) { }


  tinymceConfig = {
    height: 500,
    menubar: true,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount'
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | ' +
      'alignleft aligncenter alignright alignjustify | ' +
      'bullist numlist outdent indent | removeformat | help'
  };



  formGroup: UntypedFormGroup = new UntypedFormGroup({
    guidanceCategoryId: new UntypedFormControl('', Validators.required),
    guidanceCardId: new UntypedFormControl('', Validators.required),
    guidanceDetail: new UntypedFormControl('', Validators.required),
    guidanceBrief: new UntypedFormControl(''),
    // guidanceDetail_image: new UntypedFormControl('', Validators.required),
  });

  ngOnInit(): void {
    this.formGroup.patchValue({ userId: this.userdata.getId() })
    this.formGroup.patchValue({ addedBy: this.userdata.getName() })
    this.getCategoriesList()
    this.getCardsList()
  }

  categories: any[] = []

  getCategoriesList() {
    this.spinner.show()
    this.guidanceService.getGuidanceCategory({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.categories = res.data;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }
  cards: any[] = []

  getCardsList() {
    this.spinner.show()
    this.guidanceService.getGuidanceCards({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.cards = res.data;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  get f() {
    return this.formGroup.controls
  }

  uploadImage(event: any) {
    this.formGroup.patchValue({ 'guidanceDetail_image': event.target.files[0] });
  }

  submit() {
    this.spinner.show()
    // let data = new FormData();
    // data.append('guidanceDetail', this.formGroup.value.guidanceDetail ?? '');
    // data.append('guidanceCategoryId', this.formGroup.value.guidanceCategoryId ?? '');
    // data.append('guidanceCardId', this.formGroup.value.guidanceCardId ?? '');
    // data.append('guidanceBrief', this.formGroup.value.guidanceBrief ?? '');
    // data.append('guidanceDetail_image', this.formGroup.value.guidanceDetail_image ?? '');
    this.guidanceService.addGuidanceDetail(this.formGroup.value).subscribe(
      (res: any) => {
        if (res.success) {
          this.spinner.hide()
          this.toast.success(res.message, 'Success')
          this.route.navigateByUrl('/admin/guidance-detail/list')
        }
        else {
          this.spinner.hide()
          this.toast.error(res.message)
        }
      }, err => {
        this.spinner.hide()
        this.toast.error(err.error.message, 'Error')
      }
    )
  }



}
